import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { pdfSharedStyles } from '../pdfSharedStyles';
import { PdfFooterProps } from './types/PdfCommonTypes';

/**
 * Unified PDF Footer Component
 * Eliminates duplication across 10+ PDF files and provides configurable footer display
 */
export const PdfFooter: React.FC<PdfFooterProps> = ({ t, customText, customNotice }) => (
    <View style={pdfSharedStyles.projectInfoFooter} fixed>
        <Text>{customText || t('pdf_footer') || 'MACread eDesign'}</Text>
        <Text>{customNotice || t('pdf_footer_notice') || 'Footer notice'}</Text>
    </View>
);
